import React, { useEffect, useRef } from 'react'
import { mooncatparser } from '../lib'
import { useAppContext } from '../libs/contextLib';
import RouterLink from './RouterLink';

function drawCat(catId, size) {
  size = size || 10;
  var data = mooncatparser(catId);
  var canvas = document.createElement("canvas");
  canvas.width = size * data.length;
  canvas.height = size * data[1].length;
  var ctx = canvas.getContext("2d");

  for (var i = 0; i < data.length; i++) {
    for (var j = 0; j < data[i].length; j++) {
      var color = data[i][j];
      if (color) {
        ctx.fillStyle = color;
        ctx.fillRect(i * size, j * size, size, size);
      }
    }
  }
  return canvas.toDataURL();
}

export default function Mooncat({ catId, details= true, name }) {

  const { serials, allWrapped } = useAppContext()

  const canvasRef = useRef(null)

  useEffect(() => {

    if (!canvasRef.current) {
      return
    }

    const dataUrl = drawCat(catId, 150)
    canvasRef.current.src = dataUrl

    return () => {
      // cleanup
    }
  }, [])


  return (
    <div style={{  padding: '1rem', display: 'flex', flexDirection: 'column', border: '1px solid #444'}}>
      <img ref={canvasRef}  style={{ marginBottom: 10, marginTop: 'auto', width: 150, height: 150, objectFit: 'contain' }}/>
      <div style={{ marginBottom: 5 }}>Id: {catId}</div>
      {name && <div style={{ marginBottom: 5 }}>Name: {name}</div>}
      <div>Serial: {serials[catId]}</div>
      <div>Wrapped: {allWrapped ? (allWrapped[catId] ? <a target="_blank" href={`https://opensea.io/assets/0x7c40c393dc0f283f318791d746d894ddd3693572/${allWrapped[catId]}?ref=0x6efef34e81fd201edf18c7902948168e9ebb88ae`} >{allWrapped[catId]}</a> : '-') : '-' }</div>
      {details && <RouterLink catId={catId}>Details</RouterLink> }
    </div>
  )
}
